<template>
  <div>
    <!-- 选课时间 -->
    <div class="select-course" v-if="!initLoading">
      <span>选课时间：</span>
      <a-date-picker :defaultValue="selectCourseObj ? moment(selectCourseObj.startTime, dateFormat) : null
        " :showTime="{
          hideDisabledOptions: true,
          defaultValue: moment('08:00:00', 'HH:mm:ss'),
        }" show-time placeholder="请选择" v-model="selectCourseTimeStart" />~
      <a-date-picker :defaultValue="selectCourseObj ? moment(selectCourseObj.endTime, dateFormat) : null
        " show-time placeholder="请选择" :showTime="{
          hideDisabledOptions: true,
          defaultValue: moment('23:59:59', 'HH:mm:ss'),
        }" v-model="selectCourseTimeEnd" />

      <!-- <a-range-picker
        @disabledHours="disabledHours"
        :defaultValue="
          selectCourseObj
            ? [
                moment(selectCourseObj.startTime, dateFormat),
                moment(selectCourseObj.endTime, dateFormat),
              ]
            : null
        "
        class="picker"
        format="YYYY-MM-DD HH:mm:ss"
        :showTime="{
          hideDisabledOptions: true,
          defaultValue: [
            moment('08:00:00', 'HH:mm:ss'),
            moment('23:59:59', 'HH:mm:ss'),
          ],
        }"
        v-model="selectCourseTime"
      /> -->
      <a-button @click="showTermModal" type="primary" style="margin-left: 20px">应用到所有班级</a-button>
    </div>

    <div class="select-radio">
      选课课程类型限制：
      <a-radio-group name="radioGroup" v-model="chooseClassType">
        <a-radio value="0"> 不限制 </a-radio>
        <a-radio value="1"> 全部类型三选一 </a-radio>
        <a-radio value="2"> 全部类型三选二 </a-radio>
      </a-radio-group>
    </div>

    <!-- 选课设置 -->
    <div class="select-course">
      <div class="left">选课设置：本次选课期间内：</div>

      <div class="list">
        <!-- <a-checkbox-group v-model="chooseClassType" @change="changeCourse"> -->
        <div class="item">
          <span class="key">报班总数：</span>
          <a-input-number :min="0" :max="1000" v-model="reqClass.choose_class"></a-input-number>&nbsp;门
        </div>
        <div class="item">
          <span class="key">特色课：</span>
          <a-input-number class="college-num" :min="0" :max="1000" v-model="reqClass.college_times"
            ref="college"></a-input-number>&nbsp;门
          <!-- <a-checkbox
              value="1"
              :defaultChecked="chooseClassType.indexOf('1') > -1"
              @change="changeCollege"
            >
              计入报班总数
            </a-checkbox> -->
        </div>
        <div class="item">
          <span class="key">社团课：</span>
          <a-input-number :min="0" :max="1000" v-model="reqClass.club_class" ref="club"></a-input-number>&nbsp;门
          <!-- <a-checkbox
              value="2"
              :defaultChecked="chooseClassType.indexOf('2') > -1"
              @change="changeClub"
            >
              计入报班总数
            </a-checkbox> -->
        </div>
        <div class="item">
          <span class="key">托管班：</span>
          <a-input-number :min="0" :max="1000" v-model="reqClass.managed_class" ref="managed"></a-input-number>&nbsp;门
          <!-- <a-checkbox
              value="3"
              :defaultChecked="chooseClassType.indexOf('3') > -1"
              @change="changeManaged"
            >
              计入报班总数
            </a-checkbox> -->
        </div>
        <!-- </a-checkbox-group> -->
      </div>

      <!-- 是否允许退费设置 -->
      <div class="select-radio" style="padding-left: 0;">
        <span style="margin-top: 3px;">家长端是否允许申请退费（申请退课）：</span>
        <div>
          <a-radio-group name="radioGroup" v-model="refundSetting" @change="allowRefundTime = ''">
            <p>
              <a-radio value="0">允许退费</a-radio>
              <a-tooltip>
                <template slot="title">
                  可为空，订单仅在设定日期范围内允许申请退费，不填写或超出学期结束日期，则最晚不超过订单对应学期结束日期可发起申请退费（申请退课）。
                </template>
                <span>退费截止：
                  <a-date-picker class="modal-form-item" show-time v-model="allowRefundTime" />
                </span>
              </a-tooltip>
            </p>
            <p><a-radio value="1">不允许退费</a-radio></p>
            <p><a-radio value="2">按教育局站点设置</a-radio></p>
          </a-radio-group>
          <div v-for="item in refundTermList" :key="item.id" style="font-size: 14px;">
            {{ item.termName }}（{{ item.startDate }}至{{ item.endDate }}），{{ item.allowRefund == 1 ? '允许退费，截止时间' +
              item.allowRefundDate : '不允许退费' }}
          </div>
        </div>
      </div>
      <div class="refund-tips">
        <p><span>*</span>选择选项“允许退费”或“不允许退费”时，将忽略教育局的学期退费设置，订单是否允许退费以本校设置为准。</p>
        <p><span>*</span>选择允许退费时，订单仅在设定日期范围内允许申请退费，不填写或超出学期结束日期，则最晚不超过订单对应学期结束日期可发起申请退费（申请退课）。</p>
        <p><span>*</span>如果时间不在选课时间段内，则选课限制类型将不受限制</p>
      </div>

      <div class="oper">
        <a-button type="primary" @click="setAll()">更新</a-button>
      </div>
    </div>
    <div class="df">
      <div class="select-course" style="width: 240px;">
        <div class="time">
          <div class="w120">上课时间：</div>
          <a-button type="primary" @click="openModal()">添加</a-button>
        </div>
        <ul style="width: 240px;">
          <li v-for="(item, index) in baseClassList" :key="index">
            <span class="w120">{{ item.startTime }} 至 {{ item.endTime }}</span>
            <a><span class="del" @click="deleteToClassTime(item.id)">删除</span></a>
          </li>
        </ul>
      </div>
      <div class="term-list">
        <a-table :columns="columns" :dataSource="termList" :rowKey="getRowKey" :pagination="false">
          <span slot="allowEnroll" slot-scope="text">
            <template>
              <span class="pl20">
                <a-icon v-if="text == 0" style="color: red;" type="close-circle" />
                <a-icon v-else style="color: #37c894;" type="check-circle" />
              </span>
            </template>
          </span>
          <span slot="termFreeCharge" slot-scope="text">
            <template>
              <span class="pl20">
                <a-icon v-if="text == 1" style="color: red;" type="close-circle" />
                <a-icon v-else style="color: #37c894;" type="check-circle" />
              </span>
            </template>
          </span>
          <span slot="allowRefund" slot-scope="text">
            <template>
              <span class="pl20">
                <a-icon v-if="text == 0" style="color: red;" type="close-circle" />
                <a-icon v-else style="color: #37c894;" type="check-circle" />
              </span>
            </template>
          </span>
          <span slot="gmtModified" slot-scope="text,record">
            <template>
              <span>
                {{ record.gmtModified ? record.gmtModified : record.gmtCreate }}
              </span>
            </template>
          </span>
        </a-table>
      </div>
    </div>
    <a-modal title="选择时间段" :maskClosable="false" :width="640" :visible="visible" :cancelText="'取消'" :okText="'确定'"
      @ok="handleSubmit" @cancel="handleCancel">
      <!-- 上课时间段 -->
      <div>
        <span>选择开始时间&nbsp;</span>
        <a-time-picker format="HH:mm" placeholder="请选择时间" v-model="toClass.startTime" />
        &nbsp;&nbsp;
        <span>课节时长&nbsp;</span>
        <a-select default-value="45" style="width: 120px" @change="toClassGap_change" v-model="duration">
          <a-select-option v-for="(item, index) in classTimeInterval" :key="index" :value="item">
            {{ item }}
          </a-select-option>
        </a-select>
        <span>&nbsp;分钟</span>
        <div style="margin-top: 20px">
          <span>结束时间：{{
            toClass.endTime ? toClass.endTime.format('HH:mm') : ''
          }}</span>
        </div>
      </div>
    </a-modal>

    <a-modal :maskClosable="false" :closable="false" :width="640" :visible="adhibitionVisible" :cancelText="'取消'"
      :okText="'确定'" :centered="true" @ok="handleTerm" @cancel="cancelTerm">
      <a-form style="margin-top: 20px" :form="form">
        <a-form-item label="请选择要修改的学期" :labelCol="{ lg: { span: 9 } }" :wrapperCol="{ lg: { span: 13 } }">
          <a-select v-decorator="[
            'termId',
            { rules: [{ required: true, message: '请选择学期' }] },
          ]" @focus="getTermList" placeholder="请选择">
            <a-select-option v-for="item in teaTermDtos" :key="item.id">
              {{ item.termName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="请选择要修改班级的状态" :labelCol="{ lg: { span: 9 } }" :wrapperCol="{ lg: { span: 13 } }">
          <a-select v-decorator="[
            'stateId',
            { rules: [{ required: true, message: '请选择状态' }] },
          ]" placeholder="请选择">
            <a-select-option v-for="item in stateList" :key="item.code">
              {{ item.desc }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment'

import education from '../../api/education'

import bureau from '../../api/bureau'

import { getDateHour, getDate, getDateSecond } from '../../utils/date'

import dayjs from 'dayjs'

const columns = [
  {
    title: '学期名称',
    dataIndex: 'termName',
    key: 'termName',
  },
  {
    title: '开始日期',
    dataIndex: 'startDate',
    key: 'startDate',
  },
  {
    title: '结束日期',
    dataIndex: 'endDate',
    key: 'endDate',
  },
  {
    title: '开放报名',
    dataIndex: 'allowEnroll',
    key: 'allowEnroll',
    scopedSlots: { customRender: 'allowEnroll' },
  },
  {
    title: '开放收费',
    dataIndex: 'termFreeCharge',
    key: 'termFreeCharge',
    scopedSlots: { customRender: 'termFreeCharge' },
  },
  {
    title: '允许退费',
    dataIndex: 'allowRefund',
    key: 'allowRefund',
    scopedSlots: { customRender: 'allowRefund' },
  },
  {
    title: '退费截止',
    dataIndex: 'allowRefundDate',
    key: 'allowRefundDate',
  }
]
export default {
  name: 'classroom',
  data() {
    return {
      columns,
      termList: [],
      visible: false,
      toClass: {
        startTime: null,
        endTime: null,
      },
      baseClassList: [], //上课时间
      selectCourseTime: null, //选课时间
      selectCourseTimeStart: null, //选课开始时间
      selectCourseTimeEnd: null, //选课结束时间
      selectCourseObj: null, //选课时间默认-后台数据
      chooseClassType: 0, //选课课程类型限制
      refundSetting: '0', // 是否允许退费设置
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      allowRefundTime: '', // 退费截止时间
      initLoading: true, //初始化
      duration: 0, //间隔时间
      // reqClass: {
      //   choose_class: null,
      //   '1': null,
      //   '2': null,
      //   '3': null,
      // },
      reqClass: {
        choose_class: null,
        college_times: null,
        club_class: null,
        managed_class: null,
      },
      checkList: [],
      // classTimeInterval: [
      //   30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 125, 130,
      //   135, 140, 145, 150, 160, 165, 170, 175, 180,
      // ], //课节时长列表
      classTimeInterval: [],
      college: false, // 特色课复选框
      club: false, // 社团课复选框
      managed: false, // 托管班复选框
      courseNum: 0, // 所选课程总数
      isSet: true, // 是否可以更新
      adhibitionVisible: false, //应用到所有班级弹框
      adhibitionLoading: false, //应用到所有班级弹框确定按钮loading效果
      form: this.$form.createForm(this),
      teaTermDtos: [],
      stateList: [],
      bureauId: '',
      requesting: false,
      refundTermList: []
    }
  },
  watch: {
    'toClass.startTime': {
      handler: function () {
        this.countEndTime()
      },
      deep: true,
    },
  },

  methods: {
    getTermRefund() {
      education.getTermRefundData().then((res) => {
        this.refundTermList = res.data
        res.termList.forEach(item => {
          item.startDate = dayjs(item.startDate).format('YYYY-MM-DD')
          item.endDate = dayjs(item.endDate).format('YYYY-MM-DD')
        })
        this.termList = res.termList
      })
    },
    handleTerm() {
      this.form.validateFields((err, value) => {
        if (!err) {
          let status
          if (value.stateId == '0,-1,1') {
            status = value.stateId.split(',')
          } else {
            status = value.stateId
          }
          let data = {
            schoolId: this.$store.getters.schoolId,
            termId: value.termId,
            status,
            startTime: moment(this.selectCourseTimeStart).format(
              'YYYY-MM-DD HH:mm:ss'
            ),
            endTime: moment(this.selectCourseTimeEnd).format(
              'YYYY-MM-DD HH:mm:ss'
            ),
          }
          console.log('data', data)
          education.applyToClassChooseCourseTime(data).then((res) => {
            this.adhibitionVisible = false
            this.$message.success('操作成功')
            this.form.setFieldsValue({ termId: undefined })
            this.form.setFieldsValue({ stateId: undefined })
          })
        }
      })
      console.log('确认')
    },
    //关闭弹框
    cancelTerm() {
      this.adhibitionVisible = false
    },
    //获取学期数据
    getTermList() {
      education.getTermList().then((res) => {
        console.log('getTermListres', res)
        this.teaTermDtos = res.teaTermDtos
        this.stateList = [{ desc: '全部', code: '0,-1,1' }, ...res.classStatus]
      })
    },
    //获取数据，弹框显示
    showTermModal() {
      if (!this.selectCourseTimeStart || !this.selectCourseTimeEnd) {
        this.$message.error('请选择选课时间')
        return
      }
      if (this.selectCourseTimeStart > this.selectCourseTimeEnd) {
        this.$message.error('开始时间不能大于结束时间')
        return
      }

      this.adhibitionVisible = true
      this.getTermList()
    },
    moment,
    openModal() {
      this.visible = true
      this.duration = 0
      this.toClass = {
        startTime: null,
        endTime: null,
      }
    },

    //课节市场改变
    toClassGap_change() {
      this.countEndTime()
    },

    //保存信息一起发送
    setAll() {
      if (this.requesting) return
      this.requesting = true
      console.log('chooseClassType', Array.isArray(this.chooseClassType))
      // 判断是否为空
      if (Array.isArray(this.chooseClassType) || this.chooseClassType == '') {
        this.isSet = false
      }
      // 更新
      if (this.isSet) {
        if (this.selectCourseTimeStart > this.selectCourseTimeEnd) {
          this.$message.error('开始时间不能大于结束时间')
          return
        }
        Promise.all([this.setSelectCourseTime(), this.setChooseClass()]).then(() => {
          this.requesting = false
        })
      } else if (
        this.chooseClassType == '' ||
        Array.isArray(this.chooseClassType)
      ) {
        this.$message.error('请设置选课课程类型限制')
        this.requesting = false
      }
      // else {
      //   this.$message.error('计入报班数不得大于报班总数')
      // }
    },

    //计算结束时间  开始时间 + 时间间隔
    countEndTime() {
      let startTime = this.toClass.startTime
      let endTime = startTime
        ? moment(startTime).add(this.duration, 'minutes')
        : ''
      this.$set(this.toClass, 'endTime', endTime)
    },

    //禁用部分消失
    disabledHours() {
      return []
    },

    //设置选课
    setChooseClass() {
      // this.calcClass(this.checkList)
      let req = [
        {
          settingKey: 'choose_class',
          settingValue: this.reqClass.choose_class,
        },
        {
          settingKey: 'college_times',
          settingValue: this.reqClass.college_times,
        },
        {
          settingKey: 'club_class',
          settingValue: this.reqClass.club_class,
        },
        {
          settingKey: 'managed_class',
          settingValue: this.reqClass.managed_class,
        },
        {
          settingKey: 'choose_class_type',
          settingValue: this.chooseClassType,
        },
        {
          settingKey: 'school_refund_settings',
          settingValue: this.refundSetting,
        },
        // {
        //   settingKey: 'choose_class_type',
        //   settingValue: this.chooseClassType.join(','),
        // },
      ]
      if (this.refundSetting == 0 && this.allowRefundTime) {
        console.log(0 + ',' + dayjs(this.allowRefundTime).format('YYYY-MM-DD HH:mm:ss'))
        req[5].settingValue = 0 + ',' + dayjs(this.allowRefundTime).format('YYYY-MM-DD HH:mm:ss')
      }
      education
        .createOrUpdateSetting({ settingFormJSON: JSON.stringify(req) })
        .then((res) => {
          console.log('设置报班', res)
        })
    },

    //选课时间
    setSelectCourseTime() {
      if (!this.selectCourseTimeStart || !this.selectCourseTimeEnd) {
        return
      }

      let req = {
        startTime: getDateSecond(this.selectCourseTimeStart),
        endTime: getDateSecond(this.selectCourseTimeEnd),
      }

      // console.log('req', req)
      education.setSelectCourseTime(req).then((res) => {
        this.$message.success('更新成功')
      })
    },

    //上课时间的List
    getClassTimeList() {
      education.getClassTimeList().then((res) => {
        this.baseClassList = res.data
      })
    },

    //取消新增
    handleCancel() {
      this.visible = false
    },

    //提交新增表单
    handleSubmit() {
      if (!this.duration) {
        this.$message.warn('课节时间不能为0')
        return
      }
      let req = {
        startTime: getDateHour(this.toClass.startTime),
        endTime: getDateHour(this.toClass.endTime),
      }
      education.setToClassTime(req).then((res) => {
        this.getClassTimeList()
        this.$message.success('添加成功')
        this.handleCancel()
      })
    },

    //删除上课时间段
    deleteToClassTime(id) {
      education.deleteToClassTime(id).then((res) => {
        this.$message.success('删除成功')
        this.deleteToClassTime_data(id)
      })
    },

    //删除前端对应数据
    deleteToClassTime_data(id, value) {
      let tempList = this.baseClassList
      for (let i = 0; i < tempList.length; i++) {
        if (tempList[i].id == id) {
          tempList.splice(i, 1)
          break
        }
      }
    },

    //查询选课时间
    getSelectCourseTime() {
      education.getSelectCourseTime().then((res) => {
        this.selectCourseObj = res.data
        console.log('res.data', res.data)
        if (res.data) {
          this.selectCourseTimeStart = moment(res.data.startTime)
          this.selectCourseTimeEnd = moment(res.data.endTime)
          this.selectCourseTime = [
            moment(res.data.startTime),
            moment(res.data.endTime),
          ]
        } else {
          this.selectCourseTime = []
        }
        this.initLoading = false
      })
    },

    getValue(list, key) {
      let res = ''
      list.map((item) => {
        if (item.settingKey == key) {
          res = item.settingValue
        }
      })
      return res
    },

    //获取对应的设置
    getSetting() {
      education.getSetting({ bureauId: this.bureauId }).then((res) => {
        console.log('getSetting', res)
        if (res.data && res.data.length > 0) {
          res.data.map((item) => {
            // if (item.settingKey == 'choose_class') {
            //   this.reqClass.choose_class = item.settingValue
            // }
            // if (item.settingKey == 'college_times') {
            //   this.reqClass['1'] = item.settingValue
            // }
            // if (item.settingKey == 'club_class') {
            //   this.reqClass['2'] = item.settingValue
            // }
            // if (item.settingKey == 'managed_class') {
            //   this.reqClass['3'] = item.settingValue
            // }
            // if (item.settingKey == 'choose_class_type') {
            //   this.chooseClassType = item.settingValue.split(',')
            // }
            if (item.settingKey == 'choose_class') {
              this.reqClass.choose_class = item.settingValue
            }
            if (item.settingKey == 'college_times') {
              this.reqClass.college_times = item.settingValue
            }
            if (item.settingKey == 'club_class') {
              this.reqClass.club_class = item.settingValue
            }
            if (item.settingKey == 'managed_class') {
              this.reqClass.managed_class = item.settingValue
            }
            if (item.settingKey == 'choose_class_type') {
              this.chooseClassType = item.settingValue
            }
            if (item.settingKey == 'school_refund_settings') {
              if (item.settingValue.includes(',')) {
                this.refundSetting = item.settingValue.split(',')[0]
                this.allowRefundTime = item.settingValue.split(',')[1]
              } else {
                this.refundSetting = item.settingValue
              }
            }
          })
        }
      })
    },
    // // 特色课复选框
    // changeCollege(e) {
    //   console.log(e)
    //   this.college = e.target.defaultChecked
    //   if (this.college) {
    //     this.chooseClassType.push('1')
    //   }
    //   let index = this.chooseClassType.indexOf('1')
    //   if (index > -1) {
    //     this.chooseClassType.splice(index, 1)
    //   }
    // },
    // // 社团课复选框
    // changeClub(e) {
    //   this.club = e.target.defaultChecked
    //   if (this.club) {
    //     this.chooseClassType.push('2')
    //   }
    //   let index = this.chooseClassType.indexOf('2')
    //   if (index > -1) {
    //     this.chooseClassType.splice(index, 1)
    //   }
    // },
    // // 托管班复选框
    // changeManaged(e) {
    //   this.managed = e.target.defaultChecked
    //   if (this.managed) {
    //     this.chooseClassType.push('3')
    //   }
    //   let index = this.chooseClassType.indexOf('3')
    //   if (index > -1) {
    //     this.chooseClassType.splice(index, 1)
    //   }
    // },

    // inputNumber(e) {
    //   this.calcClass(this.chooseClassType)
    // },

    // // checkboxGroup
    // changeCourse(keys) {
    //   this.calcClass(keys)
    // },

    // // 计算课程总数
    // calcClass(arr) {
    //   this.courseNum = arr.reduce((a, key) => a + Number(this.reqClass[key]), 0)
    //   if (this.courseNum > this.reqClass.choose_class) {
    //     this.isSet = false
    //   } else {
    //     this.isSet = true
    //   }
    // },

    refreshSchool() {
      this.init()
    },
    getRowKey(record, index) {
      return index;
    },
    //初始化
    init() {
      if (this.$store.getters.schoolId) {
        //上课
        this.getClassTimeList()
        this.getSelectCourseTime()
        this.getSetting()
      }
    },
  },
  created() {
    bureau.getBureauId().then((res) => {
      this.bureauId = res
    })
    for (var i = 30; i <= 720; i += 5) {
      this.classTimeInterval.push(i)
    }
    // this.init()
    this.getTermRefund()
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

ul {
  vertical-align: top;
  display: inline-block;
  width: 424px;
  margin: 22px 0px;

  li {
    padding: 6px 10px;
    border-bottom: 1px solid $border-color;
    font-size: 0px;

    span {
      padding: 0px 2px;
      display: inline-block;
      font-size: 16px;
    }

    .oper {
      float: right;
      cursor: pointer;
      color: $primary-color;
    }
  }

  .add-toClass {
    font-size: 14px;
    color: $primary-color;
    cursor: pointer;
  }
}

// 退费设置提示
.refund-tips {
  font-size: 14px;
  font-weight: bold;

  span {
    color: red;
  }
}
::v-deep .ant-table-tbody {
  td {
    padding: 7.5px 6px !important;
  }
}
.df {
  display: flex;

  .term-list {
    padding: 16px 0 0 160px;
    min-width: 850px;
    flex: 0.9;
    .pl20 {
      padding-left: 20px;
    }
  }

  .w120 {
    width: 120px;
  }

  .time {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 3px 0 3px 10px;
  }

  .del {
    color: $primary-color;
    margin-left: 40px;
  }
}

.select-course {
  padding: 20px 10px;
  font-size: 16px;

  .left {
    display: inline-block;
    vertical-align: top;
    position: relative;
    top: 4px;
  }

  .list {
    display: inline-block;
    vertical-align: top;

    /deep/ .ant-checkbox-group {
      >.item {
        margin-bottom: 16px;

        .ant-checkbox-wrapper {
          margin-left: 16px;

          span {
            padding: 0;
          }
        }

        >.key {
          display: inline-block;
          min-width: 80px;
          text-align: right;
        }
      }
    }
  }

  >.oper {
    padding-left: 222px;
    margin-top: 10px;
    border-bottom: 1px solid $border-color;
    width: 500px;
    padding-bottom: 30px;
  }

  // .picker {
  //   vertical-align: middle;
  //   width: 400px !important;
  // }
  // .oper {
  //   margin-left: 18px;
  // }
  // .add{
  //   text-align: right;
  // }
}

.select-radio {
  padding: 10px;
  display: flex;

  p {
    line-height: 32px;
  }
}
</style>
